import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { Dropdown, Menu, message } from "antd";
import AdminSidebar from "../admin/AdminSidebar";
import "../admin/css/admin.css";
import { withBase } from "../config/env";
import { clearSession, getStoredUser } from "../utils/authSession";

export default function AdminLayout() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Load user from localStorage
  useEffect(() => {
    const loadUser = () => setUser(getStoredUser());
    loadUser();
    window.addEventListener("user-changed", loadUser);
    window.addEventListener("storage", loadUser);
    return () => {
      window.removeEventListener("user-changed", loadUser);
      window.removeEventListener("storage", loadUser);
    };
  }, []);

  // Logout handler
  const handleLogout = () => {
    clearSession();
    navigate("/login");
  };

  // helpers (top of file)
  const buildImageUrl = (p) => {
    if (!p) return "";
    const url = withBase(String(p));
    return url || "";
  };

  // dynamic placeholder with initials
  const avatarFromName = (name) =>
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      name || "User"
    )}&background=E6F7FF&color=1890FF&bold=true&size=128`;

  // final static icon if everything fails
  const FALLBACK_ICON = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

  // Admin-only dropdown menu
  const userMenu = (
    <Menu>
      <Menu.Item key="profile" onClick={() => navigate("/admin/profile")}>
        Profile
      </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="admin-layout-outer">
      <header className="admin-header">
        <div className="admin-header-left">
          <div className="logo logo-inline">
            <Link to="/admin/dashboard" className="logo-link">
              <span className="text-bold">Click</span>
              <span className="text-gold">Law</span>
            </Link>
          </div>
        </div>

        <Dropdown overlay={userMenu} trigger={["click"]}>
          <div className="admin-header-right" style={{ cursor: "pointer" }}>
            <img
              src={user?.image ? buildImageUrl(user.image) : avatarFromName(user?.name)}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = FALLBACK_ICON;
              }}
              alt={user?.name || "User"}
              className="avatar"
            />
            <div className="meta">
              <div className="name">{user?.name || ""}</div>
              <div className="email">{user?.email || ""}</div>
            </div>
          </div>
        </Dropdown>
      </header>

      <div className="admin-layout">
        <AdminSidebar />
        <div className="admin-main">
          <main className="admin-content">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
